import { sendEvent } from './iFrameUtils';
import { getOffsetTop, getScrollTop } from './Utilities';
import { SectionData } from '@/typings/interfaces/data/section';
import { ContentData } from '@/typings/interfaces/data/content';
import store from '@/store';
import { AddonGameflowModel } from '@/components/addons/gameflow/Model';
import { DeviceTypes } from '@/typings/enums/enums';
import { FlowpageModel } from '@/components/layout/FlowpageModel';

let fictiveFlowPageCounter = 0;

export const goToFictiveFlowPage = (title: string, content: ContentData) => {
  const campaignModel = store.getters['campaign/model'];
  const currentFlowIndex = store.getters['campaign/flowIndex'];

  if (currentFlowIndex === null || currentFlowIndex === undefined) {
    throw new Error('Unable to activate fictive flowpage when there is none currently viewed');
  }

  // In case this is called multiple times for multiple flowpages.. increment the id.
  fictiveFlowPageCounter++;

  const id = 9999999 + fictiveFlowPageCounter;

  const flowPage: SectionData = {
    id,
    original_id: id,
    config: {
      title,
      hidden: false,
      locked: false
    },
    title,
    programmatic: true,
    content: [content]
  };

  store.commit('campaign/setFictiveFlowPage', new FlowpageModel(flowPage, campaignModel));
};

export const scrollFlowIntoFocus = () => {
  const campaignModel = store.getters['campaign/model'];
  const gameFlowSection = campaignModel.state.sections.find((page) => page.getAddons('gameflow').length > 0);
  const gameFlowAddon = gameFlowSection?.getAddons<AddonGameflowModel>('gameflow');

  // If no gameflow addon exists, do nothing.
  if (!gameFlowAddon || !gameFlowSection) {
    return;
  }

  const flowScroll = !!gameFlowAddon[0].state.settings.flowScroll;

  if (!flowScroll) {
    return;
  }

  const gameFlowSectionEl = document.querySelector<HTMLDivElement>(`.section--${gameFlowSection.id}`);

  if (!gameFlowSectionEl) {
    return;
  }

  // Get "simulated" device from store.
  const currentDevice = store.getters['global/currentDevice'];
  const editorViewerEl = document.querySelector<HTMLDivElement>('.editor__viewer');

  // If simulating a device, scroll the editor viewer container instead of the window
  if (editorViewerEl && (currentDevice === DeviceTypes.MOBILE || currentDevice === DeviceTypes.TABLET)) {
    if (getScrollTop(editorViewerEl) > getOffsetTop(gameFlowSectionEl)) {
      editorViewerEl.scrollTo({
        top: getOffsetTop(gameFlowSectionEl) - getOffsetTop(editorViewerEl),
        behavior: 'smooth'
      });
    }
  } else {
    if (gameFlowSectionEl.getBoundingClientRect().top < 0) {
      gameFlowSectionEl.scrollIntoView({
        behavior: 'smooth'
      });
    }
  }

  sendEvent('scroll-to-top');
};
